import React, { useEffect, useRef } from "react";

const DynamicChart = ({ llmResponse, id, isPreview = false }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!llmResponse) return;

        // Extract <div> and <script> content from the LLM response
        const divContentMatch = llmResponse.match(/<div[^>]*>([\s\S]*?)<\/div>/);
        const scriptContentMatch = llmResponse.match(/<script\b[^>]*>([\s\S]*?)<\/script>/gi);

        // Inject the div content into the container
        if (divContentMatch && containerRef.current) {
            let replacedDivContent
            if (isPreview) {
                replacedDivContent = divContentMatch[0]?.replace("id=\"chart\"", `id=chart-preview-${id}`).replace("id='chart'", `id=chart-preview-${id}`);
            } else {
                replacedDivContent = divContentMatch[0]?.replace("id=\"chart\"", `id=chart-${id}`).replace("id='chart'", `id=chart-preview-${id}`);
            }
            containerRef.current.innerHTML = replacedDivContent; // Inject div content
        }

        // Dynamically add D3 and execute the script content
        const loadD3AndRunScript = () => {
            if (!scriptContentMatch || !scriptContentMatch[1]) return;

            // Check if D3 is already loaded
            // This code will never execute, as we have d3 library added in CC, but Just in case
            if (!window.d3) {
                const d3Script = document.createElement("script");
                d3Script.src = "https://d3js.org/d3.v7.min.js";
                d3Script.async = true;
                d3Script.onload = () => executeScript(scriptContentMatch[1]);
                document.body.appendChild(d3Script);
            } else {
                // If D3 is already loaded, execute the script immediately
                executeScript(scriptContentMatch[1]);
            }
        };

        // Function to execute the extracted script
        const executeScript = (scriptContent) => {
            try {
                // Create and append a script to the DOM
                const script = document.createElement("script");
                script.id = `script-${id}`;
                script.async = true
                const replacedScriptTag = scriptContent?.replace("<script>", "").replace("</script>", "");
                let replacedDivId = ""
                if (isPreview) {
                    replacedDivId = replacedScriptTag?.replace("d3.select(\"#chart\")", `d3.select("#chart-preview-${id}")`).replace("d3.select('#chart')", `d3.select("#chart-preview-${id}")`)
                } else {
                    replacedDivId = replacedScriptTag?.replace("d3.select(\"#chart\")", `d3.select("#chart-${id}")`).replace("d3.select('#chart')", `d3.select("#chart-${id}")`)
                }
                //const replaceHeight = replacedDivId.replace(/const height = \d+;/, "const height = 375")
                // const replaceWidth = replaceHeight.replace(/const width = \d+;/, "const width = 640")
                // all const variables are globallay declared in script, reinitialize having error
                const replaceConstToLet = replacedDivId?.replaceAll("const ", "var ")
                script.textContent = replaceConstToLet
                document.body.appendChild(script);

                // Cleanup to avoid multiple executions
                setTimeout(() => {
                    // @ts-ignore
                    // delete data
                    document.body.removeChild(script);
                }, 5000)

            } catch (error) {
                console.error("Error executing script:", error);
            }
        };

        // Delay to ensure DOM is ready
        setTimeout(loadD3AndRunScript, 100);
    }, [llmResponse]);

    return <div className={`d3-chart-${id}`} ref={containerRef}></div>;
};

export default DynamicChart;